//@flow
import React from 'react';

export function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <circle transform="translate(8 0)" cx="0" cy="16" r="0">
          <animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0"
            keyTimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"
          />
        </circle>
        <circle transform="translate(16 0)" cx="0" cy="16" r="0">
          <animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.3"
            keyTimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"
          />
        </circle>
        <circle transform="translate(24 0)" cx="0" cy="16" r="0">
          <animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.6"
            keyTimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline"
          />
        </circle>
      </svg>
    </div>
  );
}

type Props = {
  isLoading:boolean,
  defaultText:string,
  disabled?:boolean,
  className?:string,
  onClick?:()=>void,
  buttonId?:string,
};

export default function LoadingButton(props:Props) {
  const content = props.isLoading ? LoadingSpinner() : props.defaultText;
  return (
    <button
      className={props.className || "cta"}
      type="submit"
      aria-label={props.defaultText}
      disabled={props.disabled || props.isLoading}
      onClick={props.onClick}
      id={props.buttonId || ""}
    >
      {content}
    </button>
  );
}
